import { Alert, Box, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';
import AuthLayout from './AuthLayout';

const SignupPage = () => {
    const { t } = useTranslation();

    const subtitleElement = (
        <Box sx={{ fontSize: '0.95rem' }}>{t('auth.signup.hasAccount')} <Link
            component={RouterLink}
            to="/login"
            sx={{
                color: 'text.primary',
                textDecoration: 'underline',
                '&:hover': {
                    color: 'text.secondary'
                }
            }}
            aria-label={t('auth.signup.loginLinkAriaLabel')}
        >
            {t('auth.signup.loginLink')}
        </Link></Box>
    );

    return (
        <AuthLayout
            title={t('auth.signup.disabledTitle')}
            subtitle={subtitleElement}
        >
            <Alert
                severity="info"
                sx={{
                    width: '100%',
                    marginTop: '8px',
                    borderRadius: 1,
                }}
                role="status"
            >
                {t('auth.signup.disabledMessage')}
            </Alert>
        </AuthLayout>
    );
};

export default SignupPage;
